import { render } from "./SessionExpiryModal.vue?vue&type=template&id=53654b8a"
import script from "./SessionExpiryModal.vue?vue&type=script&lang=js"
export * from "./SessionExpiryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__